import React from "react"

import AppStoreButton from "../../appStoreButton/AppStoreButton"

import arrow from "../../../assets/general/arrow.svg"
import logo from "../../../assets/brand/logo.svg"

import card1 from "../../../assets/cards/card1.png"
import card2 from "../../../assets/cards/card2.png"
import card3 from "../../../assets/cards/card3.png"
import card4 from "../../../assets/cards/card4.png"
import card5 from "../../../assets/cards/card5.png"

import style from "./Card.module.scss"

type CardProps = { index: number }
type CTACardProps = {}
type HowCardProps = {}

const cards = [card1, card2, card3, card4, card5]

const Card: React.FC<CardProps> = ({ index }) => {
  if (index === 0) return <CTACard />
  if (index === 6) return <HowCard />

  return (
    <div className={style.imageContainer}>
      <img src={cards[cards.length - index]} alt="Agile Coaching Card" />
    </div>
  )
}

const CTACard: React.FC<CTACardProps> = ({}) => {
  return (
    <div className={style.ctaContainer}>
      <div className={style.content}>
        <h4 className="bold large">Download the Agile Coaching Cards app now for free!</h4>
        <AppStoreButton isAppleStore={true} />
        <AppStoreButton isAppleStore={false} />
      </div>

      <img className={style.logo} src={logo} alt="Inspect & Adapt Logo" />
    </div>
  )
}

const HowCard: React.FC<HowCardProps> = ({}) => {
  return (
    <div className={style.howContainer}>
      <div className={style.content}>
        <h4 className="bold large">Working in product or software development?</h4>
        <p className="medium center">SWIPE FOR INSPIRATION</p>
        <img src={arrow} alt="Swipe Right" />
      </div>

      <img className={style.logo} style={{ height: 40 }} src={logo} alt="Inspect & Adapt Logo" />
    </div>
  )
}

export default Card
